import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: 8,
        mt: 8,
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/')}
          sx={{
            mb: 4,
            color: 'primary.main',
            '&:hover': {
              backgroundColor: 'rgba(108, 59, 248, 0.08)',
            },
          }}
        >
          Back to Home
        </Button>

        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="h3" component="h1" gutterBottom>
            Privacy Policy
          </Typography>
          
          <Typography variant="body1" paragraph>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            1. Introduction
          </Typography>
          <Typography variant="body1" paragraph>
            SMOD ("we", "our", or "us") respects your privacy and is committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            2. Data We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Identity Data: includes first name, last name, username</li>
            <li>Contact Data: includes email address and telephone numbers</li>
            <li>Technical Data: includes internet protocol (IP) address, browser type and version</li>
            <li>Usage Data: includes information about how you use our website and services</li>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            3. How We Use Your Data
          </Typography>
          <Typography variant="body1" paragraph>
            We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>To provide and maintain our service</li>
            <li>To notify you about changes to our service</li>
            <li>To provide customer support</li>
            <li>To gather analysis or valuable information to improve our service</li>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            4. Data Security
          </Typography>
          <Typography variant="body1" paragraph>
            We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors, and other third parties who have a business need to know.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            5. Your Legal Rights
          </Typography>
          <Typography variant="body1" paragraph>
            Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Request access to your personal data</li>
            <li>Request correction of your personal data</li>
            <li>Request erasure of your personal data</li>
            <li>Object to processing of your personal data</li>
            <li>Request restriction of processing your personal data</li>
            <li>Request transfer of your personal data</li>
            <li>Right to withdraw consent</li>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            6. Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about this privacy policy or our privacy practices, please contact us at:
          </Typography>
          <Typography variant="body1" paragraph>
            Email:  info@thesmod.com
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy; 